import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getMediaList } from "../../services/logout";
import "./media.css"
import { format, parseISO } from 'date-fns';
import { useTranslation } from "react-i18next";

const Media = () => {
  const { t } = useTranslation("publicMisc");
  const location = useLocation();
  const [mediaList, setMediaList] = useState([]);
  const [reasonFilter, setReasonFilter] = useState('');
  const [mediaTypeFilter, setMediaTypeFilter] = useState('');

  // Dynamically determine the page title
  const getTitle = () => {
    if (location.pathname === "/mediums-media") return t("media.titleMediums");
    if (location.pathname === "/clients-media") return t("media.titleClients");
    if (location.pathname === "/general-public") return t("media.titleGeneralPublic");
    return t("media.title");
  };
   const routeToTypeMap = {
    "/mediums-media": "mediums",
    "/clients-media": "clients",
    "/general-public": "general-public",
  };
  useEffect(() => {
    let type = routeToTypeMap[location.pathname] || "mediums";
    const filters = {
      reason: reasonFilter,
      mediaType: mediaTypeFilter,
    };
  console.log(filters);
    getMediaList(type,filters)
      .then((data) => {

        if (data.data.status) {
          console.log(data.data.data)
          setMediaList(data.data.data);
        }
      })
      .catch(() => { });
  }, [reasonFilter, mediaTypeFilter, location.pathname]);

  return (
    <>
      {/* Top Header */}
      <div className="login-registerheader">
        <div className="container">
          <div className="logo-top">
            {" "}
            <img src="images/logo-verysoul.png" alt="logo" />
          </div>
          <div className="right-login-register">
            <p>

              {/* <Link to={"/login"}>Login</Link> */}
            </p>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="container mt-4">
        <h3 className="fw-bold text-media">{getTitle()}</h3>
        <div className="row mt-3">
          <div className="col-md-6 mb-3">
            <label htmlFor="reasonFilter" className="form-label">
              {t("media.filterByReason")}
            </label>
            <select
              className={`selectmenu-element form-item__element--select has-placeholder url-input-info url-input-info-select custom-select-modern`}
              name="content_type"
              id="content_type"
              value={reasonFilter}
              onChange={(e) => setReasonFilter(e.target.value)}
             
            >
              <option disabled value="">
                {t("media.select")}
              </option>
              <option value="About VerySoul">{t("media.reasons.aboutVerySoul")}</option>
              <option value="Mentions VerySoul">{t("media.reasons.mentionsVerySoul")}</option>
              <option value="Aligns with VerySoul Mission">{t("media.reasons.alignsWithMission")}</option>
              <option value="Other Reason">{t("media.reasons.otherReason")}</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="mediaTypeFilter" className="form-label">
              {t("media.filterByType")}
            </label>
            <select
              className={`selectmenu-element form-item__element--select has-placeholder url-input-info url-input-info-select custom-select-modern`}
              name="content_type"
              id="content_type"
               value={mediaTypeFilter}
              onChange={(e) => setMediaTypeFilter(e.target.value)}
            >
              <option disabled value="">
                {t("media.select")}
              </option>
              <option value="Blog Post">{t("media.mediaTypes.blogPost")}</option>
              <option value="Social Media Post (Instagram, LinkedIn, X)">{t("media.mediaTypes.socialMediaPost")}</option>
              <option value="YouTube">{t("media.mediaTypes.youTube")}</option>
              <option value="Podcast">{t("media.mediaTypes.podcast")}</option>
              <option value="Email Newsletter">{t("media.mediaTypes.emailNewsletter")}</option>
              <option value="Infographic">{t("media.mediaTypes.infographic")}</option>
              <option value="Reel / Short / TikTok">{t("media.mediaTypes.reelShortTikTok")}</option>
              <option value="Webinar">{t("media.mediaTypes.webinar")}</option>
              <option value="Case Study">{t("media.mediaTypes.caseStudy")}</option>
              <option value="E-book / Guide">{t("media.mediaTypes.ebookGuide")}</option>
              <option value="Testimonial (Text or Video)">{t("media.mediaTypes.testimonial")}</option>
              <option value="Live Stream (Instagram, Facebook, LinkedIn)">{t("media.mediaTypes.liveStream")}</option>
              <option value="Quiz / Poll">{t("media.mediaTypes.quizPoll")}</option>
              <option value="Whitepaper">{t("media.mediaTypes.whitepaper")}</option>
              <option value="Explainer Video">{t("media.mediaTypes.explainerVideo")}</option>
              <option value="Product Demo">{t("media.mediaTypes.productDemo")}</option>
              <option value="Slide Deck / Presentation">{t("media.mediaTypes.slideDeck")}</option>
              <option value="Press Release">{t("media.mediaTypes.pressRelease")}</option>
              <option value="Interactive Tool (calculator, checklist)">{t("media.mediaTypes.interactiveTool")}</option>
              <option value="News Article / Editorial">{t("media.mediaTypes.newsArticle")}</option>
            </select>

          </div>
        </div>
      </div>
      {/*  List */}
      {mediaList.map((item, index) => (
        <div key={index}>
          <div className="container mt-5">
            <h4 className="fw-bold text-dark">
              {item.title}
            </h4>
            <p className="mb-1">
              <span className="me-2 text-decoration-underline">{item.reason}</span> {" | "}
              <em><strong>{item.content_type}</strong></em>
            </p>

            <div className="row mt-3">
              {/* <div className="col-md-2">
                    <img
                      src="images/undraw_profile_1.svg"
                      alt="Podcast"
                      className="img-fluid rounded"
                    />
                  </div> */}
              <div className="col-md-10 d-flex align-items-center" style={{ minHeight: "100%" }}>
                <p className="mb-0 py-3 text-justify font-size-16">
                  {item.description}
                </p>
              </div>
            </div>

            <div className="d-flex flex-column align-items-start mt-3">
              <div className="text-muted mb-2">
                <img
                  src="images/clanderNew.png"
                  alt="Podcast"
                  className="img-fluid me-2"
                  style={{ width: "16px", height: "16px", marginTop: "-2px" }}
                />{" "}
                {format(parseISO(item.created_at), 'MMMM d, yyyy')}
                
              </div>
              <a
                  href={item.url}
                  className="btn btn-media d-flex justify-content-center align-items-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("media.view")}
                </a>
            </div>
          </div>
          {index !== mediaList.length - 1 && <hr className="my-4 text-muted" />}
        </div>
      ))}
      <div className='footer-saction-home'>
        <div className="container">
          <div className='footer-logo-home'><img src="images/Union-icon.png" /> </div>
          <p>{t("media.footer.tagline")}</p>
          <ul>
            <li>
              <Link target='_blank' to={'/terms-conditions'}>{t("media.footer.terms")}</Link>
              {/* <a href='#'>Terms& Conditions</a> */}
            </li>
            <li>|</li>
            <li>
              <Link target='_blank' to={'/privacy-policy'}>{t("media.footer.privacy")}</Link>
              {/* <a href='#'>Privacy Policy</a> */}
            </li>
          </ul>
          {/* <span><b>Note: For optimum performance: use Chrome, Safari, or Edge</b></span> */}
          <span>{t("media.footer.copyright")}</span>
        </div>
      </div>
    </>
  );
};
export default Media;
